module.exports = __webpack_public_path__ + "img/sidebar_tweet_ipad.83173aef.svg";